export const toFixedTwoDecimal = val => (val > 0 ? Number(val).toFixed(2) : 0);

export function formatAmountWithCommas(amount) {
  if (amount === null || amount === undefined || amount === '') return '-';

  const numericValue =
    typeof amount === 'string' ? Number(amount.replace(/,/g, '')) : amount;

  if (Number.isNaN(numericValue)) return '-';

  return numericValue.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }); // // Use 'en-US' for million/billion
}

export function truncateNumber(num, decimals = 2) {
  const factor = 10 ** decimals;
  return Math.trunc(num * factor) / factor;
}
